import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/transparent.png'


const _withScopeId = n => (_pushScopeId("data-v-d842db9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-background" }
const _hoisted_2 = { class: "tradist-container py-32 grid grid-cols-1 xl:grid-cols-2" }
const _hoisted_3 = { class: "create justify-self-center space-y-8 order-2 xl:order-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "create__header" }, "Create new collection", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "create__information" }, " A small fee per NFT may be charged reflecting network costs. ", -1))
const _hoisted_6 = { class: "create__file-upload--plus--wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block mt-2" }, "Choose File", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block mt-2" }, "JPG, PNG, GIF, MP4 , Max size 32mb.", -1))
const _hoisted_9 = {
  for: "creation-description",
  class: "create__label"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Description ")
const _hoisted_11 = { class: "mt-4 flex flex-wrap" }
const _hoisted_12 = { class: "mt-4 space-y-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "create__label" }, "Attributes", -1))
const _hoisted_14 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "create__label" }, " ETH ", -1))
const _hoisted_16 = { class: "flex justify-between items-center" }
const _hoisted_17 = {
  key: 0,
  class: "create__label"
}
const _hoisted_18 = { class: "flex space-x-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " List NFT immediately ", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Create ")
const _hoisted_21 = { class: "preview justify-self-center order-1 xl:order-2 xl:justify-self-start mb-20" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preview__text" }, " Preview ", -1))
const _hoisted_23 = { class: "preview__image--wrapper" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "preview__image",
  src: _imports_0
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preview__image--placeholder" }, " Preview of your new collectible ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HollowXIcon = _resolveComponent("HollowXIcon")!
  const _component_MaterialInputWithLabel = _resolveComponent("MaterialInputWithLabel")!
  const _component_BaseTextarea = _resolveComponent("BaseTextarea")!
  const _component_BaseSelectItem = _resolveComponent("BaseSelectItem")!
  const _component_BaseSelect = _resolveComponent("BaseSelect")!
  const _component_TagButton = _resolveComponent("TagButton")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_VueNumberInput = _resolveComponent("VueNumberInput")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseToaster = _resolveComponent("BaseToaster")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("label", {
          for: "file-upload",
          class: "create__file-upload",
          onDrag: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePreventDefaultDrag && _ctx.handlePreventDefaultDrag(...args))),
          onDragstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePreventDefaultDrag && _ctx.handlePreventDefaultDrag(...args))),
          onDragend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePreventDefaultDrag && _ctx.handlePreventDefaultDrag(...args))),
          onDragover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlePreventDefaultDrag && _ctx.handlePreventDefaultDrag(...args))),
          onDragenter: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlePreventDefaultDrag && _ctx.handlePreventDefaultDrag(...args))),
          onDragleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handlePreventDefaultDrag && _ctx.handlePreventDefaultDrag(...args))),
          onDrop: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFileDrop && _ctx.handleFileDrop(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_HollowXIcon, { class: "create__file-upload--plus" })
          ]),
          _hoisted_7,
          _hoisted_8
        ], 32),
        _createElementVNode("input", {
          id: "file-upload",
          type: "file",
          accept: "image/jpeg,image/png",
          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleFileUploadByClick && _ctx.handleFileUploadByClick(...args))),
          hidden: ""
        }, null, 32),
        _createVNode(_component_MaterialInputWithLabel, {
          inputId: "creation-title",
          label: "Title",
          modelValue: _ctx.formState.title,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.title) = $event)),
          labelClasses: "text-sm"
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_BaseTextarea, {
            id: "creation-description",
            modelValue: _ctx.formState.description,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.description) = $event)),
            class: "mt-3 text-base w-full h-32 p-3 dark:text-white"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_BaseSelect, {
          multiple: "",
          text: "Tags",
          data: _ctx.tags,
          displayKey: "value",
          onSearchSelect: _ctx.handleSelectedUnregisteredTag
        }, {
          default: _withCtx(({ multiple, item, displayKey, index }) => [
            _createVNode(_component_BaseSelectItem, {
              item: item,
              index: index,
              uniqueKey: "id",
              multiple: multiple,
              displayKey: displayKey,
              selectedItems: _ctx.formState.tags,
              onSelected: _ctx.handleSelectedTags,
              onUnselected: _ctx.handleUnselectedTags
            }, null, 8, ["item", "index", "multiple", "displayKey", "selectedItems", "onSelected", "onUnselected"])
          ]),
          _: 1
        }, 8, ["data", "onSearchSelect"]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formState.tags, (item, index) => {
            return (_openBlock(), _createBlock(_component_TagButton, {
              key: index,
              text: item.value,
              class: "mr-2 mb-2",
              onClick: () => _ctx.handleTagRemove(index)
            }, null, 8, ["text", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formState.attributes, (attribute, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `attribute-${index}`,
              class: "flex space-x-4 items-center attribute-wrapper"
            }, [
              _createVNode(_component_BaseInput, {
                class: "material-input",
                modelValue: attribute.key,
                "onUpdate:modelValue": ($event: any) => ((attribute.key) = $event),
                placeholder: "Key",
                maxlength: "20"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_BaseInput, {
                class: "material-input",
                modelValue: attribute.value,
                "onUpdate:modelValue": ($event: any) => ((attribute.value) = $event),
                placeholder: "Value",
                maxlength: "20",
                onKeyup: _withKeys(() => _ctx.focusAndAddAttribute(index), ["enter"])
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"]),
              _createVNode(_component_XIcon, {
                class: "w-6 h-6 cursor-pointer",
                onClick: () => _ctx.removeAttribute(index)
              }, null, 8, ["onClick"])
            ]))
          }), 128)),
          _createElementVNode("span", {
            class: "create__add-attribute",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addAttribute && _ctx.addAttribute(...args)))
          }, " + Add More ")
        ]),
        (_ctx.config.LIST_NFT_IMMEDIATELY && _ctx.formState.listNFTImmediately)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_VueNumberInput, {
                modelValue: _ctx.formState.price,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.price) = $event)),
                class: "w-full mr-1",
                inline: ""
              }, null, 8, ["modelValue"]),
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.config.LIST_NFT_IMMEDIATELY)
            ? (_openBlock(), _createElementBlock("label", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_BaseCheckbox, {
                    modelValue: _ctx.formState.listNFTImmediately,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.listNFTImmediately) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_19
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_BaseButton, {
            fontWeight: 600,
            textColor: "theme",
            bgColor: "transparent",
            disabled: _ctx.isButtonDisabled,
            onClick: _ctx.handleCreate
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createElementVNode("section", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          (_ctx.previewImage.url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "preview__image",
                src: _ctx.previewImage.url,
                alt: _ctx.previewImage.alt
              }, null, 8, _hoisted_24))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_25,
                _hoisted_26
              ], 64))
        ])
      ])
    ]),
    _createVNode(_component_BaseToaster, {
      active: _ctx.toaster.visible,
      text: _ctx.toaster.text,
      buttonText: _ctx.toaster.buttonText,
      type: _ctx.toaster.type,
      onClick: _ctx.toaster.action
    }, null, 8, ["active", "text", "buttonText", "type", "onClick"])
  ]))
}